import { useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchPeriodsRequest } from '../../actions/fetchPeriodsActions';
import {
  chosenCourseLivePeriodsSelector,
  periodSelector,
  periodsErrorSelector,
  periodsLoadingSelector,
  periodsSelector,
  selectedCourseSelector,
} from '../../reducers/selectors';

const usePeriods = () => {
  const dispatch = useDispatch();
  const originPeriods = useSelector(periodsSelector);
  const periods = useSelector(chosenCourseLivePeriodsSelector);
  const selectedCourse = useSelector(selectedCourseSelector);
  const selectedPeriod = useSelector(periodSelector);
  const isLoading = useSelector(periodsLoadingSelector);
  const error = useSelector(periodsErrorSelector);
  const reload = () => null;
  const data = periods.map(period => {
    const { className = '', periodName, periodGuid: value } = period;

    return {
      value,
      label: `${className} (${periodName})`,
    };
  });

  useLayoutEffect(() => {
    if (!error && !isLoading && selectedCourse && !originPeriods[selectedCourse.value]) {
      dispatch(fetchPeriodsRequest(selectedCourse.value));
    }
  }, [dispatch, originPeriods, error, isLoading, selectedCourse]);

  return {
    data,
    periods,
    selectedPeriod,
    isLoading,
    error,
    reload,
    beforeStep: selectedCourse,
  };
};

export default usePeriods;
